import { api } from "./api";

const MONTHS = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];

export function documentDate(month, year) {
  const monthIndex = MONTHS.findIndex((name) => name.toLowerCase() === String(month || "").trim().toLowerCase());
  if (monthIndex < 0 || !/^\d{4}$/.test(String(year || ""))) {
    return "Tanggal dokumen tidak tersedia";
  }

  const numericYear = Number(year);
  if (numericYear < 1) return "Tanggal dokumen tidak tersedia";
  const isLeapYear = numericYear % 4 === 0 && (numericYear % 100 !== 0 || numericYear % 400 === 0);
  const daysInMonth = [31, isLeapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return `Bandung, ${daysInMonth[monthIndex]} ${MONTHS[monthIndex]} ${numericYear}`;
}

/**
 * Fetch master aset from backend and build signature objects for A5Matrix.
 * Returns { left, right } with keys { title, subtitle, nama, nip, url_ttd, url_stempel }.
 *
 * scope: "kelurahan" | "rw" | "rt"
 * rw, rt: strings (zero-padded)
 */
export async function loadSignatures(scope, rw, rt, month, year) {
  let list = [];
  try {
    const res = await api.masterAsetList();
    list = res?.data || [];
  } catch (_) { list = []; }

  const find = (s, r, t) =>
    list.find((a) =>
      a.scope === s
      && (r ? a.rw === String(r).padStart(2, "0") : !a.rw)
      && (t ? a.rt === String(t).padStart(3, "0") : !a.rt)
    );

  const kelurahanAset = find("kelurahan", null, null);
  const rwAset = rw ? find("rw", rw, null) : null;
  const rtAset = (rw && rt) ? find("rt", rw, rt) : null;
  const lurahAset = /lurah/i.test(kelurahanAset?.jabatan || "") ? kelurahanAset : null;

  const dateStr = documentDate(month, year);

  if (scope === "rt") {
    return {
      left: {
        title: "Mengetahui,",
        subtitle: `Ketua RW ${rw}`,
        nama: rwAset?.nama || "................",
        nip: rwAset?.nip || "",
        url_ttd: rwAset?.url_ttd,
        url_stempel: rwAset?.url_stempel,
      },
      right: {
        title: dateStr,
        subtitle: `Ketua RT ${rt}`,
        nama: rtAset?.nama || "................",
        nip: rtAset?.nip || "",
        url_ttd: rtAset?.url_ttd,
        url_stempel: rtAset?.url_stempel,
      },
    };
  }

  const lurahSignature = {
    title: "Mengetahui,",
    subtitle: "Lurah Suka Asih",
    nama: lurahAset?.nama || "................",
    nip: lurahAset?.nip || "",
    url_ttd: lurahAset?.url_ttd,
    url_stempel: lurahAset?.url_stempel,
  };

  if (scope === "kelurahan") {
    return {
      right: {
        ...lurahSignature,
        title: dateStr,
      },
    };
  }

  return {
    left: lurahSignature,
    right: {
      title: dateStr,
      subtitle: `Ketua RW ${rw}`,
      nama: rwAset?.nama || "................",
      nip: rwAset?.nip || "",
      url_ttd: rwAset?.url_ttd,
      url_stempel: rwAset?.url_stempel,
    },
  };
}
